/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Body_Assessment_Protocol_Field_BarefootInputs */

const en_us2_body_assessment_protocol_field_barefoot = /** @type {(inputs: Body_Assessment_Protocol_Field_BarefootInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`shoes on`)
};

const pt_br2_body_assessment_protocol_field_barefoot = /** @type {(inputs: Body_Assessment_Protocol_Field_BarefootInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`calçado nos pés`)
};

const es_419_body_assessment_protocol_field_barefoot = /** @type {(inputs: Body_Assessment_Protocol_Field_BarefootInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`con zapatos`)
};

const pt_pt2_body_assessment_protocol_field_barefoot = /** @type {(inputs: Body_Assessment_Protocol_Field_BarefootInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`calçado nos pés`)
};

const fr_fr2_body_assessment_protocol_field_barefoot = /** @type {(inputs: Body_Assessment_Protocol_Field_BarefootInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`chaussures aux pieds`)
};

const de_de2_body_assessment_protocol_field_barefoot = /** @type {(inputs: Body_Assessment_Protocol_Field_BarefootInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schuhe an`)
};

const it_it2_body_assessment_protocol_field_barefoot = /** @type {(inputs: Body_Assessment_Protocol_Field_BarefootInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`scarpe ai piedi`)
};

/**
* | output |
* | --- |
* | "shoes on" |
*
* @param {Body_Assessment_Protocol_Field_BarefootInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const body_assessment_protocol_field_barefoot = /** @type {((inputs?: Body_Assessment_Protocol_Field_BarefootInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Body_Assessment_Protocol_Field_BarefootInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_body_assessment_protocol_field_barefoot(inputs)
	if (locale === "es-419") return es_419_body_assessment_protocol_field_barefoot(inputs)
	if (locale === "pt-PT") return pt_pt2_body_assessment_protocol_field_barefoot(inputs)
	if (locale === "fr-FR") return fr_fr2_body_assessment_protocol_field_barefoot(inputs)
	if (locale === "de-DE") return de_de2_body_assessment_protocol_field_barefoot(inputs)
	if (locale === "it-IT") return it_it2_body_assessment_protocol_field_barefoot(inputs)
	return en_us2_body_assessment_protocol_field_barefoot(inputs)
});
export { body_assessment_protocol_field_barefoot as "body-assessment.protocol_field.barefoot" }